import moment from 'moment';

import { isPhoneMethodSelected } from './RepresentativeOutreach';
import {
  DateTimeModel,
  OutreachEnum,
  OutreachModel,
} from 'api/backofficeApiClient';

export interface OutreachDate {
  date: string | null;
  time: string | null;
  timePeriod: string;
  tz: string | null;
}

export interface OutreachFormValues {
  memberEmail?: string;
  memberPhoneNumber?: string;
  contactMethod?: OutreachEnum;
  outreachDates: Array<OutreachDate>;
}

const getDateTimeData = (outreach: OutreachDate) => {
  const { date, time, timePeriod, tz } = outreach;

  const formattedDate = moment(date).format('MM/DD/YYYY');
  const utcFormattedDate = moment.utc(formattedDate);
  const formattedDateTime = moment
    .utc(`${formattedDate} ${time} ${timePeriod}`)
    .format('HH:mm');

  return {
    date: utcFormattedDate.toDate(),
    time: formattedDateTime,
    timeZone: tz as string,
  };
};

export const mapOutreachDataToRequest = (values: OutreachFormValues) => {
  const {
    outreachDates,
    contactMethod,
    memberEmail,
    memberPhoneNumber,
  } = values;

  const outreachDateTimes = outreachDates.reduce((acc, outreach) => {
    if (!outreach.date || !outreach.time || !outreach.tz) return acc;

    const combinedOutreach = getDateTimeData(outreach);

    return [...acc, combinedOutreach];
  }, [] as Array<DateTimeModel>);

  const outreachData: OutreachModel = {
    outreachType: contactMethod,
    dates: outreachDateTimes.length ? outreachDateTimes : undefined,
  };

  if (isPhoneMethodSelected(contactMethod) && memberPhoneNumber) {
    outreachData.phone = memberPhoneNumber.replace(/\D+/g, '');
  } else {
    outreachData.email = memberEmail;
  }

  return outreachData;
};
